/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MLGraph API
 * # MLGraph API Documentation

MLGraph is a high-performance system for processing and clustering records based on configurable matching conditions.

## Key Features
- Dynamic record clustering with custom matching rules
- Concurrent batch processing capabilities 
- Real-time cluster analysis and visualization
- Configurable matching strategies per field

## Authentication
Currently, the API does not require authentication. All endpoints are publicly accessible.

## Rate Limiting
- Default rate limit: 1000 requests per second
- Batch endpoints: 100 requests per second

## Common Response Codes
- 200: Success
- 201: Resource created
- 400: Bad request / Invalid input
- 404: Resource not found
- 429: Rate limit exceeded
- 500: Internal server error

 * OpenAPI spec version: 1.0.0
 */
import type {
  AddRecordRequest,
  AddRecordResponse,
  ClusterDetailsResponse,
  ClusterDistributionResponse,
  ClusterGraphResponse,
  CreateClusterRequest,
  GetClustersClusterNameRecordsParams,
  HealthResponse,
  ListClustersResponse,
  PaginatedListRecordsResponse
} from '../utils/models';

import { mlgraphInstance } from './api-client';
export const getMLGraphAPI = () => {
/**
 * Returns a list of all available clusters
 * @summary List all clusters
 */
const getClusters = (
    
 ) => {
      return mlgraphInstance<ListClustersResponse>(
      {url: `/clusters`, method: 'GET'
    },
      );
    }
  
const getClusterIdsBySize = async (clusterName: string, size: number) => {
  // mlgraphInstance(...) *is* your JSON body already
  return mlgraphInstance<{
    cluster_name: string;
    size: number;
    number_of_clusters: number;
    cluster_ids: number[];
  }>({
    url: `/clusters/${clusterName}/size/${size}`,
    method: 'GET',
  });
};
/**
 * Creates a new cluster with specified configuration
 * @summary Create a new cluster
 */
const postClusters = (
    createClusterRequest: CreateClusterRequest,
 ) => {
      return mlgraphInstance<ClusterDetailsResponse>(
      {url: `/clusters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClusterRequest
    },
      );
    }
  
/**
 * Deletes a specific cluster and all its records
 * @summary Delete a cluster
 */
const deleteClustersClusterName = (
    clusterName: string,
 ) => {
      return mlgraphInstance<void>(
      {url: `/clusters/${clusterName}`, method: 'DELETE'
    },
      );
    }
  
/**
 * Returns details about a specific cluster
 * @summary Get cluster details
 */
const getClustersClusterName = (
    clusterName: string,
 ) => {
      return mlgraphInstance<ClusterDetailsResponse>(
      {url: `/clusters/${clusterName}`, method: 'GET'
    },
      );
    }
  
/**
 * Returns the distribution of cluster sizes
 * @summary Get cluster size distribution
 */
const getClustersClusterNameDistribution = (
    clusterName: string,
 ) => {
      return mlgraphInstance<ClusterDistributionResponse>(
      {url: `/clusters/${clusterName}/distribution`, method: 'GET'
    },
      );
    }
  
/**
 * Returns the graph representation of a specific cluster
 * @summary Get cluster graph
 */
const getClustersClusterNameGraphClusterId = (
    clusterName: string,
    clusterId: number,
 ) => {
      return mlgraphInstance<ClusterGraphResponse>(
      {url: `/clusters/${clusterName}/graph/${clusterId}`, method: 'GET'
    },
      );
    }
  
/**
 * Returns a paginated list of records in the cluster
 * @summary List cluster records
 */
const getClustersClusterNameRecords = (
    clusterName: string,
    params?: GetClustersClusterNameRecordsParams,
 ) => {
      return mlgraphInstance<PaginatedListRecordsResponse>(
      {url: `/clusters/${clusterName}/records`, method: 'GET',
        params
    },
      );
    }
  
/**
 * Adds a new record to the cluster
 * @summary Add a record
 */
const postClustersClusterNameRecords = (
    clusterName: string,
    addRecordRequest: AddRecordRequest,
 ) => {
      return mlgraphInstance<AddRecordResponse>(
      {url: `/clusters/${clusterName}/records`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addRecordRequest
    },
      );
    }
  
/**
 * Process multiple records in a single request
 * @summary Process records batch
 */
const postClustersClusterNameRecordsBatch = (
    clusterName: string,
    addRecordRequest: AddRecordRequest[],
 ) => {
      return mlgraphInstance<AddRecordResponse[]>(
      {url: `/clusters/${clusterName}/records/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addRecordRequest
    },
      );
    }
  
/**
 * Returns the health status and basic metrics of the API.
Use this endpoint to verify the API is operational and get basic system metrics.

 * @summary Check API health status
 */
const getHealth = (
    
 ) => {
      return mlgraphInstance<HealthResponse>(
      {url: `/health`, method: 'GET'
    },
      );
    }
  
return {getClusters,postClusters,deleteClustersClusterName,getClustersClusterName,getClustersClusterNameDistribution,getClustersClusterNameGraphClusterId,getClustersClusterNameRecords,postClustersClusterNameRecords,postClustersClusterNameRecordsBatch,getHealth, getClusterIdsBySize}};

type AwaitedInput<T> = PromiseLike<T> | T;

    type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export type GetClustersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['getClusters']>>>
export type PostClustersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['postClusters']>>>
export type DeleteClustersClusterNameResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['deleteClustersClusterName']>>>
export type GetClustersClusterNameResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['getClustersClusterName']>>>
export type GetClustersClusterNameDistributionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['getClustersClusterNameDistribution']>>>
export type GetClustersClusterNameGraphClusterIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['getClustersClusterNameGraphClusterId']>>>
export type GetClustersClusterNameRecordsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['getClustersClusterNameRecords']>>>
export type PostClustersClusterNameRecordsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['postClustersClusterNameRecords']>>>
export type PostClustersClusterNameRecordsBatchResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['postClustersClusterNameRecordsBatch']>>>
export type GetHealthResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMLGraphAPI>['getHealth']>>>

export const mlgraph = getMLGraphAPI();